import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Star, Eye, Zap, ShieldCheck, CheckCircle2 } from 'lucide-react';
export const Hero = () => {
  const [viewers, setViewers] = useState(23);
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const tick = () => {
      setViewers(prev => {
        // small organic fluctuation, kept within a believable range
        const delta = Math.floor(Math.random() * 5) - 2; // -2..+2
        let next = prev + delta;
        if (next < 14) next = 14 + Math.floor(Math.random() * 3);
        if (next > 38) next = 38 - Math.floor(Math.random() * 3);
        return next;
      });
      // random interval so it doesn't feel mechanical
      timeoutId = setTimeout(tick, 2500 + Math.random() * 3500);
    };
    timeoutId = setTimeout(tick, 3000);
    return () => clearTimeout(timeoutId);
  }, []);
  return <section className="relative pt-6 pb-8 md:pt-8 md:pb-12 overflow-hidden" data-id="element-99">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-gold-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-100" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-101">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-102">
          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="md:text-5xl lg:text-6xl font-serif font-bold mb-4 text-white text-[28px]" data-id="element-103">
            ⚖️ Dejá de empezar cada reclamo desde cero
          </motion.h1>

          {/* Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          y: 24,
          scale: 0.96
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="w-full max-w-2xl my-4 md:my-5" data-id="element-104">
            <img src="https://cdn.magicpatterns.com/uploads/sHJiyUGY1ZVsYvAeS1gk8W/c7929282-51b5-4e43-8684-f530f006bc0d.png" alt="Tratado Práctico de Defensa del Consumidor 2026: tomo principal rodeado de modelos editables, demandas, reclamos administrativos, medidas cautelares y bonos profesionales" className="w-full h-auto drop-shadow-2xl" data-id="element-105" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col items-center w-full" data-id="element-106">
            <p className="md:text-xl text-slate-300 font-medium mb-5 text-[14px] font-[Poppins,_sans-serif]" data-id="element-107">
              Trabajá reclamos de consumo con la seguridad de tener modelos,
              estrategias, jurisprudencia y fundamentos listos para aplicar
              desde el primer caso.
            </p>

            {/* Rating */}
            <div className="flex items-center gap-2 mb-5" data-id="element-108">
              <div className="flex gap-0.5" data-id="element-109">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-110" />)}
              </div>
              <span className="text-slate-300 font-semibold text-sm" data-id="element-111">
                4.9 (500+ ventas)
              </span>
            </div>

            {/* CTA below rating */}
            <motion.a href="#oferta" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 mb-5 bg-gold-500 hover:bg-gold-400 text-legal-900 font-bold rounded-lg text-lg transition-colors shadow-[0_0_20px_rgba(201,162,74,0.3)]" data-id="element-112">
              QUIERO EL TRATADO AHORA
            </motion.a>

            {/* Trust Badges */}
            <div className="mt-2 flex flex-wrap justify-center items-center gap-4 sm:gap-6 text-sm text-slate-400" data-id="element-113">
              <div className="flex items-center gap-1.5" data-id="element-114">
                <Zap className="w-4 h-4 text-gold-500" data-id="element-115" />
                Entrega inmediata
              </div>
              <div className="flex items-center gap-1.5" data-id="element-116">
                <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-117" />
                Pago seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-118">
                <CheckCircle2 className="w-4 h-4 text-gold-500" data-id="element-119" />
                Garantía de 7 días
              </div>
            </div>

            <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-red-500/40 bg-red-500/10 px-4 py-2 text-sm font-semibold text-red-400" data-id="element-120">
              <span className="relative flex h-2.5 w-2.5" data-id="element-121">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" data-id="element-122" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-red-500" data-id="element-123" />
              </span>
              <Eye className="w-4 h-4" data-id="element-124" />
              <span className="tabular-nums" data-id="element-125">{viewers}</span> profesionales
              viendo este producto ahora
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};